// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__WlcF0","left-block":"Footer_left-block__78NUt","right-block":"Footer_right-block__Zs6zS"};